document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('[data-product-form]');
  if (!form) return;

  const variantInput = form.querySelector('input[name="id"]');
  const quantityInput = document.querySelector('#Quantity');
  if (!quantityInput) return;

  const targetMin = parseInt(quantityInput.getAttribute('min') ?? 1);
  const targetMax = parseInt(quantityInput.getAttribute('max') ?? 99);
  const addButton = document.querySelector(`button[cart-quantity-target="#${quantityInput.id}"][cart-quantity-modify="1"]`);
  const subtractButton = document.querySelector(`button[cart-quantity-target="#${quantityInput.id}"][cart-quantity-modify="-1"]`);
  let priceDisplay = document.querySelector('[data-product-price]');

  function getSelectedVariant() {
    const selectedOptions = [...new Set(
      Array.from(form.querySelectorAll('input[type="radio"]'), r => r.name)
    )].map(name => form.querySelector(`input[type="radio"][name="${name}"]:checked`)?.value ?? null);

    return productVariants.find(variant =>
      variant.options.every((option, i) => option === selectedOptions[i])
    );
  }

  function resetQuantity() {
    quantityInput.value = 1;
    quantityInput.dispatchEvent(new Event('change'));
  }

  function updateButtonStates(value) {
    subtractButton?.toggleAttribute('disabled', value <= targetMin);
    addButton?.toggleAttribute('disabled', value >= targetMax);
  }

  function formatPrice(cents) {
    const dollars = cents / 100;
    return dollars % 1 === 0
      ? `$${dollars}`
      : `$${dollars.toFixed(2)}`;
  }

  form.querySelectorAll('input[type="radio"]').forEach(radio => {
    radio.addEventListener('change', () => {
      const matched = getSelectedVariant();
      if (matched) {
        console.log(matched.price);
        console.log(priceDisplay.innerHTML);
        priceDisplay.innerHTML = formatPrice(matched.price);
        variantInput.value = matched.id;
        resetQuantity();
      }
    });
  });

  quantityInput.addEventListener('change', () => {
    const value = parseInt(quantityInput.value);
    updateButtonStates(value);
  });

  document.addEventListener('click', e => {
    const btn = e.target.closest('[cart-quantity-modify][cart-quantity-target]');
    if (!btn || !quantityInput) return;

    const newQuantity = parseInt(quantityInput.value) + parseInt(btn.getAttribute('cart-quantity-modify'));
    if (newQuantity >= targetMin && newQuantity <= targetMax) {
      quantityInput.value = newQuantity;
      quantityInput.dispatchEvent(new Event('change'));
    }
  });
});